const brandNameHe = () => window.Config?.brand_Name_HE ?? '';
export const CombinedPackageData = [
  {
    mainTitle: 'הגדרות',
    content: [
      {
        title: '"דקת שיחה יוצאת"',
        get description() {
          return `דקת שיחה בחיוג מקו ה${brandNameHe()} ביעדי החבילה באמצעות שירות חו"ל מוזל למספר ישראלי.`;
        },
        subDescription: {},
      },
      {
        title: '"דקת שיחה נכנסת"',
        get description() {
          return `דקת שיחה נכנסת לקו ה${brandNameHe()} הנמצא ביעדי החבילה.`;
        },
        subDescription: {},
      },
      {
        title: '"מספר ישראלי"',
        description: 'קו טלפון ביעד בישראל בקידומת חיוג של מפעיל קווי או סלולרי ישראלי (מפ"א נייח או מפ"א נייד בישראל)',
        subDescription: {},
      },
      {
        title: '"הודעת SMS יוצאת"',
        get description() {
          return `שליחת SMS מקו ה${brandNameHe()} ביעדי החבילה למספר ברשת סלולרית ישראלית (לא כולל הודעות MMS או קבלת SMS)`;
        },
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'תעריפי החבילה והשימושים',
    content: [
      {
        title: '',
        get description() {
          return ` התשלום החד פעמי בגין החבילה מתייחס לקו ${brandNameHe()} בודד, והינו בגין החבילה שתועמד לשימושך בעת המצאות הקו ביעדי החבילה בתקופת החבילה. סכום זה מתווסף לתשלומים החלים עליך בתכנית התעריפים שלך ו/או לכל תשלום אחר בו הנך מחויב.`;
        },
        subDescription: {},
      },
      {
        title: '',
        description:
          ' החבילה כוללת רק את השימושים הקבועים בה. כל שימוש אחר יחוייב בהתאם לתעריפים הרלוונטיים לשירותים אלו כפי שיהיו בתוקף אותה עת. תעריפים אלו עשויים עשויים להשתנות מעת מעת ועליך להתעדכן בהם באופן שוטף באתר החברה או בשירות הלקוחות. מבלי לגרוע מהאמור לעיל, החבילה אינה כוללת:',
        subDescription: [
          ' שיחות יוצאות או הודעת SMS יוצאת ליעד שאינו בישראל ו/או ליעד שאינו מספר ישראלי לרבות ליעד מקומי במדינה בו הינך שוהה ו/או ליעד אחר בחו"ל.',
          'קבלת SMS מכל יעד שהוא.',
          'שימושים כלשהם באוניות ו/או במטוסים ו/או בשירות לוויני - גם אם שירות זה נעשה בטריטוריה של יעדי החבילה.',
          'שימושים, לרבות שיחות או הודעות ליעדי פרימים או ליעדים המחויבים בתשלומים מיוחדים.',
        ],
      },
      {
        title: '',
        description: 'יחידת החיוב הינה לפי דקה מלאה (60 שניות). כל יחידת שיחה בת פחות מדקה תעוגל לדקה.',
        subDescription: {},
      },
      {
        title: '',
        description: 'התשלומים מחויבים במע"מ בשיעור 0%. אם ישתנו ההנחיות בנוגע למע"מ או שיעורו, יועלו הסכומים בהסכם זה בהתאם.',
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'תוקף החבילה',
    content: [
      {
        title: '',
        description: '',
        subDescription: {},
      },
      {
        title: '',
        description: `באפשרותך להגדיר כי החבילה תותקן באופן אוטומטי לכל מנוייך או לחלקם. ככל ובחרת כי, החבילה תותקן
          באופן אוטומטי, בכל נחיתה באחד מיעדי החבילה, המנוי יהנה מתנאי החבילה ויתבצע חיוב בגין החבילה
          כמפורט בטבלה. לתשומת לבך, החבילה תיכנס לתוקף עבור המנוי עם הנחיתה באחד מיעדי החבילה, וזאת
          אף אם לא בוצע כל שימוש, או במקרה של שהות קצרה ביעד. באפשרותך לבקש לבטל את ההתקנה
          האוטומטית בכל עת`,
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'הוראות כלליות לגבי חבילת חו"ל',
    content: [
      {
        title: '',
        get description() {
          return ` השימוש בשירות יתאפשר ברשת (סלולארית) אחת בלבד בכל יעד שנקבע על ידי ${brandNameHe()} (להלן: "הרשת הנבחרת") ובאמצעות שירות חו"ל מוזל. השימוש בשירות הינו בכפוף לתנאים ולכיסוי הסלולרי המוצעים על ידי מפעילי הרשת הנבחרת הרלוונטית. מוסכם כי ${brandNameHe()} רשאית לשנות את בחירת הרשת הסלולארית בכל עת. הננו ממליצים לא לבצע חיפוש ידני ו/או אחר של רשת סלולארית אחרת מזו שנבחרה מכל סיבה שהיא, שכן התבייתות על רשת אחרת לא תהיה אפשרית ו/או השימושים בה לא יימנו במסגרת החבילה ו/או לא יקנו לך את תעריפי החבילה. לתשומת לבך, לא ניתן להתחייב כי לרשת הנבחרת יהיה כיסוי מלא ביעד הרלבנטי ו/או ייתכן כי הרשת הנבחרת תפעל בטכנולוגיה ו/או בתדר ו/או בדור מסוים בלבד שאינו נתמך על ידי מכשירך. לתשומת ליבך, קיימים מפעילים אשר אינם תומכים ברשת דור 3 ודור 2 - כך שלא ניתן לבצע שימוש ברשתות מפעילים אלו במכשירי דור 2, 3 וכן לא ניתן לבצע שימושי שיחה ברשתות אלו במכשירים שאינם תומכים ב VOLTE.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` חבילה זו אינה ניתנת להעברה למועד אחד ו/או לקו ${brandNameHe()} אחר, גם אם הינה בבעלותך. לא תהיה זכאי לכל זיכוי שהוא (כספי או אחר) בגין אי ניצול החבילה, במלואה ו/או בחלקה, מכל סיבה שהיא, לרבות במקרה בו בחרת רשת סלולארית אחרת מזו שנבחרה ע"י ${brandNameHe()}.`;
        },
        subDescription: {},
      },
      {
        title: '',
        description:
          ' החבילה חלה על שימושים באמצעות כרטיס ה-SIM שלך המשוייך לתוכנית זו. ובגלישה בקו הראשי בלבד. לתשומת לבך, קיימים יישומים (כגון: סנכרון אוטומטי של דואר אלקטרוני) הצורכים נפח נתונים, גם מבלי שתעשה פעולה יזומה על ידך.',
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` ${brandNameHe()} תהיה רשאית לשלוח אליך הודעות SMS או MMS לרבות בנוגע לסיום החבילה או הצעה לרכישת חבילות נוספות. הרכישה תתאפשר במשלוח הודעה חוזרת. בהצטרפותך לשירות זה הנך נותן את הסכמתך לקבלת הודעות כאמור ואפשרות רכישת חבילות נוספות. לתשומת ליבך, ההודעות ו/או חסימת הגלישה לא יתבצעו מיידית אלא בסמוך לאחר המועד הרלוונטי והגעתן תלוייה במפעיל המקומי.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` ${brandNameHe()} רשאית להפסיק או לשנות, מעת לעת ובהודעה מראש, את מתכונת ההתקשרות, במלואה או בחלקה לפי שיקול דעתה, ובכלל כך את התעריפים. למען הסר ספק ${brandNameHe()} רשאית לקבוע תעריפי שירותים או שימושים (גם במקרה בו השירות או השימוש במועד ההצטרפות לתוכנית היה ללא תשלום) ו/או להעלות את תעריפי כל השירותים והשימושים לרבות אלו שאינם נקובים בתוכנית זו ו/או להפסיק את שיווק התוכנית בכפוף לתנאי רשיונה.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` הינך מתבקש לעדכן את ${brandNameHe()} במספר טלפון נוסף לצורך קבלת התראות והודעות, בפרט, אם הינך עושה שימוש בטאבלט/מודם. לעדכון מספר נוסף אנא פנה ל-*123.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` בהצטרפותך לשירות זה, יבוטלו כל הסדרי, חבילות תעריפי ${brandNameHe()} חו"ל הקודמים שלך, ככל שקיימים. אין כפל הסדרים, הטבות, חבילות או הנחות אחרות.`;
        },
        subDescription: {},
      },
      {
        title: '',
        description:
          'במקרה בו הקו שלך יתביית על מפעיל שאינו שייך למדינת השהות (כמו למשל בקרבת גבול מדיני), לא תהיה זכאי לתנאי החבילה. לתשומת ליבך, על מנת לעשות שימוש בשירותי הנדידה בירדן, יש לפתוח את הקו פרטנית לשימוש באמצעות פנייה לנציג.',
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return `הוראות נספח זה הינן בנוסף לכל האמור ב"הסכם התנאים כלליים להתחברות לרשת ${brandNameHe()}", או בכל הסכם אחר בינך ובין ${brandNameHe()}. כמו כן הנך מחויב לכל ההסכמים האחרים, ויחולו עליך כל ההתחייבויות האחרות , למעט אם נאמר אחרת במפורש.`;
        },
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'הוראות בעניין גלישה באפליקציות מובחרות',
    content: [
      {
        title: '',
        description: `.חבילת הגלישה כוללת רכיב גלישה באפליקציות נבחרות ללא הגבלה בכפוף לשימוש סביר והוגן לצורך אישי ובמכשיר הקו הסלולרי של
        המנוי בו נרכשה החבילה, למשך תקופת החבילה וכל עוד נותר נפח גלישה לניצול במסגרת החבילה. במקרה בו נוצל נפח הגלישה
        בחבילה לא תתאפשר המשך גלישה באפליקציות הנבחרות , זאת אף במקרה בו תרכוש חבילה נוספת.`,

        subDescription: {},
      },
      {
        title: '',
        description: `ההצטרפות לחבילה זו הינה לבקשתך, ולבקשתך נפח רכיב האפליקציות הנבחרות גדול מנפח החבילה - הינך מוזמן לפנות אלינו בכל
        עת כדי לרכוש חבילה ללא רכיבים ייחודיים.`,
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return `במקרה בו מערכות ${brandNameHe()} ו/ המפעילים הזרים לא יזהו את השימוש באפליקציות הנבחרות , השימוש בהן )עד למועד הזיהוי ככל שיהיה
        זיהוי ( יצרוך מנפח הגלישה בחבילה. הצטרפותך לחבילה נעשית בידיעה ובהסכמה לכך`;
        },

        subDescription: {},
      },
    ],
  },
];

export const DataPackageData = [
  {
    mainTitle: 'תעריפי החבילה והשימושים',
    content: [
      {
        title: '',
        get description() {
          return ` התשלום החד פעמי בגין החבילה מתייחס לקו ${brandNameHe()} בודד, והינו בגין החבילה שתועמד לשימושך בעת המצאות הקו ביעדי החבילה בתקופת החבילה. סכום זה מתווסף לתשלומים החלים עליך בתכנית התעריפים שלך ו/או לכל תשלום אחר בו הנך מחויב.`;
        },
        subDescription: {},
      },
      {
        title: '',
        description:
          ' החבילה כוללת רק את השימושים הקבועים בה. כל שימוש אחר יחוייב בהתאם לתעריפים הרלוונטיים לשירותים אלו כפי שיהיו בתוקף אותה עת. תעריפים אלו עשויים עשויים להשתנות מעת מעת ועליך להתעדכן בהם באופן שוטף באתר החברה או בשירות הלקוחות. מבלי לגרוע מהאמור לעיל, החבילה אינה כוללת:',
        subDescription: [
          ' שיחות יוצאות או הודעת SMS יוצאת ליעד שאינו בישראל ו/או ליעד שאינו מספר ישראלי לרבות ליעד מקומי במדינה בו הינך שוהה ו/או ליעד אחר בחו"ל.',
          'קבלת SMS מכל יעד שהוא.',
          'שימושים כלשהם באוניות ו/או במטוסים ו/או בשירות לוויני - גם אם שירות זה נעשה בטריטוריה של יעדי החבילה.',
          'שימושים, לרבות שיחות או הודעות ליעדי פרימים או ליעדים המחויבים בתשלומים מיוחדים.',
        ],
      },

      {
        title: '',
        description: 'התשלומים מחויבים במע"מ בשיעור 0%. אם ישתנו ההנחיות בנוגע למע"מ או שיעורו, יועלו הסכומים בהסכם זה בהתאם.',
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'תוקף החבילה',
    content: [
      {
        title: '',
        description: '',
        subDescription: {},
      },

      {
        title: '',
        description: `באפשרותך להגדיר כי החבילה תותקן באופן אוטומטי לכל מנוייך או לחלקם. ככל ובחרת כי, החבילה תותקן
        באופן אוטומטי, בכל נחיתה באחד מיעדי החבילה, המנוי יהנה מתנאי החבילה ויתבצע חיוב בגין החבילה
        כמפורט בטבלה. לתשומת לבך, החבילה תיכנס לתוקף עבור המנוי עם הנחיתה באחד מיעדי החבילה, וזאת
        אף אם לא בוצע כל שימוש, או במקרה של שהות קצרה ביעד. באפשרותך לבקש לבטל את ההתקנה
        האוטומטית בכל עת.`,
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'הוראות כלליות לגבי חבילת חו"ל',
    content: [
      {
        title: '',
        get description() {
          return ` השימוש בשירות יתאפשר ברשת (סלולארית) אחת בלבד בכל יעד שנקבע על ידי ${brandNameHe()} (להלן: "הרשת הנבחרת") ובאמצעות שירות חו"ל מוזל. השימוש בשירות הינו בכפוף לתנאים ולכיסוי הסלולרי המוצעים על ידי מפעילי הרשת הנבחרת הרלוונטית. מוסכם כי ${brandNameHe()} רשאית לשנות את בחירת הרשת הסלולארית בכל עת. הננו ממליצים לא לבצע חיפוש ידני ו/או אחר של רשת סלולארית אחרת מזו שנבחרה מכל סיבה שהיא, שכן התבייתות על רשת אחרת לא תהיה אפשרית ו/או השימושים בה לא יימנו במסגרת החבילה ו/או לא יקנו לך את תעריפי החבילה. לתשומת לבך, לא ניתן להתחייב כי לרשת הנבחרת יהיה כיסוי מלא ביעד הרלבנטי ו/או ייתכן כי הרשת הנבחרת תפעל בטכנולוגיה ו/או בתדר ו/או בדור מסוים בלבד שאינו נתמך על ידי מכשירך. לתשומת ליבך, קיימים מפעילים אשר אינם תומכים ברשת דור 3 ודור 2 - כך שלא ניתן לבצע שימוש ברשתות מפעילים אלו במכשירי דור 2, 3 וכן לא ניתן לבצע שימושי שיחה ברשתות אלו במכשירים שאינם תומכים ב VOLTE.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` חבילה זו אינה ניתנת להעברה למועד אחד ו/או לקו ${brandNameHe()} אחר, גם אם הינה בבעלותך. לא תהיה זכאי לכל זיכוי שהוא (כספי או אחר) בגין אי ניצול החבילה, במלואה ו/או בחלקה, מכל סיבה שהיא, לרבות במקרה בו בחרת רשת סלולארית אחרת מזו שנבחרה ע"י ${brandNameHe()}.`;
        },
        subDescription: {},
      },
      {
        title: '',
        description:
          ' החבילה חלה על שימושים באמצעות כרטיס ה-SIM שלך המשוייך לתוכנית זו. ובגלישה בקו הראשי בלבד. לתשומת לבך, קיימים יישומים (כגון: סנכרון אוטומטי של דואר אלקטרוני) הצורכים נפח נתונים, גם מבלי שתעשה פעולה יזומה על ידך.',
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` ${brandNameHe()} תהיה רשאית לשלוח אליך הודעות SMS או MMS לרבות בנוגע לסיום החבילה או הצעה לרכישת חבילות נוספות. הרכישה תתאפשר במשלוח הודעה חוזרת. בהצטרפותך לשירות זה הנך נותן את הסכמתך לקבלת הודעות כאמור ואפשרות רכישת חבילות נוספות. לתשומת ליבך, ההודעות ו/או חסימת הגלישה לא יתבצעו מיידית אלא בסמוך לאחר המועד הרלוונטי והגעתן תלוייה במפעיל המקומי.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` ${brandNameHe()} רשאית להפסיק או לשנות, מעת לעת ובהודעה מראש, את מתכונת ההתקשרות, במלואה או בחלקה לפי שיקול דעתה, ובכלל כך את התעריפים. למען הסר ספק ${brandNameHe()} רשאית לקבוע תעריפי שירותים או שימושים (גם במקרה בו השירות או השימוש במועד ההצטרפות לתוכנית היה ללא תשלום) ו/או להעלות את תעריפי כל השירותים והשימושים לרבות אלו שאינם נקובים בתוכנית זו ו/או להפסיק את שיווק התוכנית בכפוף לתנאי רשיונה.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` הינך מתבקש לעדכן את ${brandNameHe()} במספר טלפון נוסף לצורך קבלת התראות והודעות, בפרט, אם הינך עושה שימוש בטאבלט/מודם. לעדכון מספר נוסף אנא פנה ל-*123.`;
        },
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return ` בהצטרפותך לשירות זה, יבוטלו כל הסדרי, חבילות תעריפי ${brandNameHe()} חו"ל הקודמים שלך, ככל שקיימים. אין כפל הסדרים, הטבות, חבילות או הנחות אחרות.`;
        },
        subDescription: {},
      },
      {
        title: '',
        description:
          'במקרה בו הקו שלך יתביית על מפעיל שאינו שייך למדינת השהות (כמו למשל בקרבת גבול מדיני), לא תהיה זכאי לתנאי החבילה. לתשומת ליבך, על מנת לעשות שימוש בשירותי הנדידה בירדן, יש לפתוח את הקו פרטנית לשימוש באמצעות פנייה לנציג.',
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return `הוראות נספח זה הינן בנוסף לכל האמור ב"הסכם התנאים כלליים להתחברות לרשת ${brandNameHe()}", או בכל הסכם אחר בינך ובין ${brandNameHe()}. כמו כן הנך מחויב לכל ההסכמים האחרים, ויחולו עליך כל ההתחייבויות האחרות , למעט אם נאמר אחרת במפורש.`;
        },
        subDescription: {},
      },
    ],
  },
  {
    mainTitle: 'הוראות בעניין גלישה באפליקציות מובחרות',
    content: [
      {
        title: '',
        description: `חבילת הגלישה כוללת רכיב גלישה באפליקציות נבחרות ללא הגבלה בכפוף לשימוש סביר והוגן לצורך אישי ובמכשיר הקו הסלולרי של
        המנוי בו נרכשה החבילה, למשך תקופת החבילה וכל עוד נותר נפח גלישה לניצול במסגרת החבילה. במקרה בו נוצל נפח הגלישה
        בחבילה לא תתאפשר המשך גלישה באפליקציות הנבחרות , זאת אף במקרה בו תרכוש חבילה נוספת.`,

        subDescription: {},
      },
      {
        title: '',
        description: `ההצטרפות לחבילה זו הינה לבקשתך, ולבקשתך נפח רכיב האפליקציות הנבחרות גדול מנפח החבילה - הינך מוזמן לפנות אלינו בכל
        עת כדי לרכוש חבילה ללא רכיבים ייחודיים.`,
        subDescription: {},
      },
      {
        title: '',
        get description() {
          return `במקרה בו מערכות ${brandNameHe()} ו/ המפעילים הזרים לא יזהו את השימוש באפליקציות הנבחרות , השימוש בהן )עד למועד הזיהוי ככל שיהיה
        זיהוי ( יצרוך מנפח הגלישה בחבילה. הצטרפותך לחבילה נעשית בידיעה ובהסכמה לכך`;
        },

        subDescription: {},
      },
    ],
  },
];
